import React from "react"
import Layout from "../components/layout"
import Homepage from "../components/Homepage"
import Seo from "../components/seo"

const guernsey = () => (
  <Layout>
    <Seo title="Guernsey weather forecast" description="Weather forecast for today and the next 5 days for Guernsey, Channel Islands from the Jersey Met Office" />
    <Homepage mode={"guernsey"} />
  </Layout>
)

export default guernsey
